import React from "react";
import frameMobile from "../../../assets/icons/iphone.png";
import arrow from "../../../assets/icons/arrow.png";
import location from "../../../assets/icons/location.png";
import "../ride.css";
import cookies from "js-cookie";

const Step = ({ item }) => {
  const lng = cookies.get("i18next") || "en";

  // تحديد ما إذا كان رقم الخطوة زوجي لتبديل اتجاه العناصر
  const isEven = item.id % 2 === 0;
  return (
    <div
      className={`step flex flex-col-reverse items-center justify-between  mx-auto ${
        isEven ? "md:flex-row" : "md:flex-row-reverse"
      }`}
    >
      {/* عمود النص والسهام */}
      <div className="flex-1 flex flex-col items-center self-end p-4">
        <div className="mt-2 relative">
          <img
            src={arrow}
            alt="arrow"
            className={` ${
              isEven && lng === "en"
                ? "scale-x-[-1]"
                : !isEven && lng === "ar"
                ? "scale-x-[-1]"
                : ""
            }`}
          />
          {item.id === 8 && (
            <img
              src={location}
              alt="arrow"
              className={`absolute -bottom-3 ${
                lng === "en" ? "-left-5" : "-right-5"
              } `}
            />
          )}
        </div>
        <span className="text-3xl font-bold text-center text-[#FAC027]">
          {item.title}
        </span>
      </div>

      {/* عمود الهاتف مع الصورة */}
      <div className="flex-1 relative flex justify-center">
        <div className="relative max-w-[300px] overflow-hidden">
          <img src={frameMobile} alt="frame" className="w-full h-auto" />
          <div className="absolute top-4 left-1/2 transform -translate-x-1/2 w-[90%] h-full overflow-hidden rounded-xl">
            <img
              src={item.img}
              alt={item.title}
              className="w-full h-[90%] object-cover"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Step;
